import request from '@/utils/request'

// 查询车辆品牌轮播图列表
export function listCarBrandCarousel(query) {
  return request({
    url: '/carBrandCarousel/carBrandCarousel/list',
    method: 'get',
    params: query
  })
}

// 查询车辆品牌轮播图分页
export function pageCarBrandCarousel(query) {
  return request({
    url: '/carBrandCarousel/carBrandCarousel/page',
    method: 'get',
    params: query
  })
}

// 查询车辆品牌轮播图详细
export function getCarBrandCarousel(data) {
  return request({
    url: '/carBrandCarousel/carBrandCarousel/detail',
    method: 'get',
    params: data
  })
}

// 根据品牌编码查询轮播图
export function getCarouselByBrandCode(brandcode) {
  return request({
    url: '/carBrandCarousel/carBrandCarousel/getByBrandCode',
    method: 'get',
    params: { brandcode }
  })
}

// 新增车辆品牌轮播图
export function addCarBrandCarousel(data) {
  return request({
    url: '/carBrandCarousel/carBrandCarousel/add',
    method: 'post',
    data: data
  })
}

// 修改车辆品牌轮播图
export function updateCarBrandCarousel(data) {
  return request({
    url: '/carBrandCarousel/carBrandCarousel/edit',
    method: 'post',
    data: data
  })
}

// 删除车辆品牌轮播图
export function delCarBrandCarousel(data) {
  return request({
    url: '/carBrandCarousel/carBrandCarousel/delete',
    method: 'post',
    data: data
  })
}
